import React, { Suspense, lazy } from 'react';
import Footer from '../components/Footer';
import useAuth from '../hooks/useAuth';

const ChatWidget = lazy(() => import('../components/ChatWidget'));
// AiChatWidget is now mounted globally in App.js so it also covers public/SEO
// pages — do not mount it here too (would double-render on internal pages).

const MainLayout = ({ children }) => {
  const { user } = useAuth();
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow ">{children}</main>
      <Footer />
      {user && user.role !== 'partner' && (
        <Suspense fallback={null}>
          <ChatWidget />
        </Suspense>
      )}
    </div>
  );
};

export default MainLayout;
